import React from "react";
import { useIsSubscribeMode } from "lib/hooks/useIsSubscribeMode";

const HideInSubscribe = ({ children }: { children: React.ReactNode }) => {
  const isSubscribeMode = useIsSubscribeMode();

  if (isSubscribeMode) return null;

  return <>{children}</>;
};

export default HideInSubscribe;
